import React from 'react';
import { NavLink } from 'react-router-dom';
import s from './AdminSidebar.module.css';
import { useAuth } from '../../contexts/AuthContext';

interface AdminSidebarProps {
    isOpen?: boolean;
    onClose?: () => void;
}

export const AdminSidebar: React.FC<AdminSidebarProps> = ({ isOpen = false, onClose }) => {
    const { user } = useAuth();
    const isMainAdmin = user?.email === 'rdb-method@ya.ru';

    const menuItems = [
        { path: '/admin/news', label: 'Новости' },
        { path: '/admin/projects', label: 'Проекты' },
        ...(isMainAdmin ? [{ path: '/admin/users', label: 'Пользователи' }] : []),
        { path: '/admin/logging', label: 'Логирование' },
        { path: '/admin/settings', label: 'Настройки' },
    ];

    return (
        <>
            <div
                className={`${s.sidebarOverlay} ${isOpen ? '' : s.hidden}`}
                onClick={onClose}
            />
            <nav className={`${s.sidebar} ${isOpen ? s.open : ''}`}>
                {menuItems.map(item => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                            `${s.navLink} ${isActive ? s.active : ''}`
                        }
                        onClick={onClose}
                    >
                        {item.label}
                    </NavLink>
                ))}
            </nav>
        </>
    );
};